import React, { useEffect, useState } from 'react';
import FileUploadComponent from './controls/FileUpload';
import DropdownComponent from './controls/DropDown';

function FinancesUploadExpenses  () {
  const [data, setData] = useState([]);
  const [accountId, setAccountId] = useState('');

  useEffect(() => {
  }, []);

  const handleAccountChange = (accountId) => {
    setAccountId(accountId);
  };

  const handleBeforeUpload = (formData) => {
    formData.append('accountId', accountId);
  };

  const handleAfterUpload = (data) => {
    setData(data);
  };

  return (
    <div>
      <h1>Upload an expenses file</h1>
      <DropdownComponent onOptionChange={handleAccountChange} endpoint="api/expenses/getexpenseaccounts" text="Choose account if not Fidelity" />
      <br></br>
      <FileUploadComponent onBeforeUpload={handleBeforeUpload} onAfterUpload={handleAfterUpload} endpoint="api/expenses/uploadexpenses" />
      <br /><br />
      <h5>Downloaded transactions - {data.length}</h5>
      {data &&
        <table className="table">
          <thead className="thead-dark">
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>OriginalField1</th>
              <th>OriginalField2</th>
              <th>OriginalField3</th>
            </tr>
          </thead>
          <tbody>
            {data?.map((transaction, index) => (
              <>
                <tr key={index} style={{ borderBottom: '0px solid #fff' }}>
                  <td>{transaction?.date}</td>
                  <td>{transaction?.amount.toLocaleString('en-US', { style: 'currency', currency: 'USD' })}</td>
                  <td>{transaction?.originalField1}</td>
                  <td>{transaction?.originalField2}</td>
                  <td>{transaction?.originalField3}</td>
                </tr>
              </>
            ))}
          </tbody >
        </table>
      }
    </div>
  );
}

export default FinancesUploadExpenses;